import { EventEmitter } from 'events'

const pluckBound = obj => key => obj[key].bind(obj)

export const disableAlwaysOnTop = Symbol('disableAlwaysOnTop')
export const enableAlwaysOnTop = Symbol('enableAlwaysOnTop')
export const isAlwaysOnTopDisabled = Symbol('isAlwaysOnTopDisabled')

let currentInstance = null

export const getCurrentInstance = () => currentInstance

export const clearCurrentInstance = () => {
  currentInstance = null
}

export const setupAlwaysOnTopApiProxy = (api, defaultEnabled) => {
  const privateEmitter = new EventEmitter()
  const pluck = pluckBound(api)
  const emit = pluck('emit')
  const on = pluck('on')
  const removeListener = pluck('removeListener')
  const listenerMap = new WeakMap()
  const service = Object.create(api)

  currentInstance = service

  let conferenceLeft = false
  api.on('readyToClose', () => { conferenceLeft = true })

  return Object.assign(service, {
    [isAlwaysOnTopDisabled]: !defaultEnabled,
    [disableAlwaysOnTop]: () => {
      service[isAlwaysOnTopDisabled] = true
      privateEmitter.emit('readyToClose')
    },
    [enableAlwaysOnTop]: () => {
      service[isAlwaysOnTopDisabled] = false
      if (!conferenceLeft) {
        privateEmitter.emit('videoConferenceJoined')
      }
    },
    emit: (...args) => {
      if (service[isAlwaysOnTopDisabled]) {
        return
      }
      return emit(...args)
    },
    on: (eventName, listener) => {
      const wrapped = (...args) => {
        if (service[isAlwaysOnTopDisabled]) {
          return
        }
        return listener(...args)
      }

      listenerMap.set(listener, wrapped)
      privateEmitter.on(eventName, listener)
      return on(eventName, wrapped)
    },
    removeListener: (eventName, listener) => {
      privateEmitter.removeListener(eventName, listener)
      if (listenerMap.has(listener)) {
        return removeListener(eventName, listenerMap.get(listener))
      }
      return api
    }
  })
}
